'use client';

import { useEffect } from 'react';

/**
 * Bloque zoom pinch, double-tap zoom et gesture zoom (iOS Safari / Android Chrome).
 * Complète la meta viewport (maximum-scale=1, user-scalable=no).
 */
export default function NoZoomGuard() {
  useEffect(() => {
    const blockGesture = (e: Event) => e.preventDefault();

    const blockCtrlWheel = (e: WheelEvent) => {
      if (e.ctrlKey) e.preventDefault();
    };

    const blockPinch = (e: TouchEvent) => {
      if (e.touches.length > 1) e.preventDefault();
    };

    const opts = { passive: false } as const;
    document.addEventListener('gesturestart', blockGesture, opts);
    document.addEventListener('gesturechange', blockGesture, opts);
    document.addEventListener('gestureend', blockGesture, opts);
    document.addEventListener('wheel', blockCtrlWheel, opts);
    document.addEventListener('touchmove', blockPinch, opts);

    return () => {
      document.removeEventListener('gesturestart', blockGesture);
      document.removeEventListener('gesturechange', blockGesture);
      document.removeEventListener('gestureend', blockGesture);
      document.removeEventListener('wheel', blockCtrlWheel);
      document.removeEventListener('touchmove', blockPinch);
    };
  }, []);

  return null;
}
